export const UNIFIED_LOGIN_REQUEST = "UNIFIED_LOGIN_REQUEST";
export const UNIFIED_LOGIN_SUCCESS = "UNIFIED_LOGIN_SUCCESS";
export const UNIFIED_LOGIN_FAIL = "UNIFIED_LOGIN_FAIL";
export const UNIFIED_LOGOUT = "UNIFIED_LOGOUT";
export const CLEAR_UNIFIED_LOGIN_ERRORS = "CLEAR_UNIFIED_LOGIN_ERRORS";